<ul class="navbar-nav me-auto mb-2 mb-lg-0">
  @for (item of menuItems; track $index) {
    @if (item.children) {
      @if (item.isTitle) {
        <li ngbDropdown class="nav-item dropdown">
          <a
            ngbDropdownToggle
            href="javascript:void(0)"
            [class]="'nav-link dropdown-toggle' + getActiveClass(item)"
            data-bs-toggle="dropdown"
            aria-current="page"
            >{{ item.label }}</a
          >
          <div
            ngbDropdownMenu
            class="dropdown-menu p-0"
            [ngClass]="{ 'dropdown-menu-dark': theme == 'dark' }"
          >
            <div class="d-lg-flex">
              @if (item.hasImage) {
                <div
                  class="mega-dropdown-column d-flex justify-content-center align-items-center rounded-3 rounded-end-0 px-0"
                  style="margin: -1px; background-color: #f3f6ff"
                >
                  <img src="assets/img/products.png" alt="Products" />
                </div>
                @for (chunk of splitArray(item.children, 10); track $index) {
                  <mega-menu-column
                    [items]="chunk"
                    [labelClassName]="theme == 'dark' ? 'text-light' : ''"
                    [activeMenuItems]="activeMenuItems"
                  />
                }
              } @else {
                @for (child of splitArray(item.children, 12); track $index) {
                  <mega-menu-column
                    [items]="child"
                    [labelClassName]="theme == 'dark' ? 'text-light' : ''"
                    [activeMenuItems]="activeMenuItems"
                  />
                }
              }
            </div>
          </div>
        </li>
      }
    } @else {
      <menu-item
        [item]="item"
        [itemClassName]="'nav-item'"
        [linkClassName]="'nav-link' + getActiveClass(item)"
      />
    }
  }
</ul>
